import ReactPlayer from 'react-player';
import ch5_img1 from 'assets/knowledge/ch5_img1.png';
import ch5_img2 from 'assets/knowledge/ch5_img2.png';
import ch5_img3 from 'assets/knowledge/ch5_img3.png';
import ch5_img4 from 'assets/knowledge/ch5_img4.png';
import ch5_img5 from 'assets/knowledge/ch5_img5.png';
import ch5_img6 from 'assets/knowledge/ch5_img6.png';
import ch5_img7 from 'assets/knowledge/ch5_img7.png';
import ch5_img8 from 'assets/knowledge/ch5_img8.png';
import ch5_img9 from 'assets/knowledge/ch5_img9.png';
import ch5_img10 from 'assets/knowledge/ch5_img10.png';
import ch5_img11 from 'assets/knowledge/ch5_img11.png';
import ch5_img12 from 'assets/knowledge/ch5_img12.png';
import ch5_img13 from 'assets/knowledge/ch5_img13.png';
import ch5_img14 from 'assets/knowledge/ch5_img14.jpg';
import ch5_img15 from 'assets/knowledge/ch5_img15.png';
import ch5_img16 from 'assets/knowledge/ch5_img16.png';
import ch5_img17 from 'assets/knowledge/ch5_img17.png';

const Chapter5 = () => {
  return <div>
  <h2>Reifen löschen</h2>
  <ReactPlayer url="https://youtu.be/oB_bkIJygFU" controls width="100%" />
  <h3>1. Einzelnen Reifen löschen</h3>
  <p>Um einen Reifen auf der WebApp löschen zu können, muss er zuerst demontiert sein. Dafür klickt man einfach auf „Reifen demontieren“, gibt dann den Grund, das Datum und die aktuelle Profiltiefe ein und geht auf „Bestätigen“. </p>
  <div className="flex gap-4 p-4">
  <img src={ch5_img1} alt="Flottenübersicht1" />
  <img src={ch5_img2} alt="Flottenübersicht2" />

  </div>
<p>Nun liegt der Reifen im Lager. Am besten schreibt man sich die Reifen-ID am Anfang auf oder kopiert sie sich, denn nun müssen wir nach dieser suchen. Am leichtesten geht das in der oberen Suchzeile. Dafür fügt man sie einfach ein und klickt direkt auf den Reifen. </p>
<img src={ch5_img3} alt="Dashboard Ansicht3" />
<p>Eine weitere Variante ist, dass man sie im Reiter Reifenbestand sucht. Dann muss man auf „Alle Reifen anzeigen“ in der richtigen Flotte gehen. </p>
<img src={ch5_img4} alt="Dashboard Ansicht4" />
<p>Unter dem Reiter „Alle“ kann man dann in der Suchleiste nach dem Reifen suchen. </p>

      <img src={ch5_img5} alt='Dashboard Ansicht5' />
      <p>
        Nun muss man nur noch auf das Mülltonnensymbol gehen, das
        Entsorgungsdatum auswählen und dann auf „Löschen“ klicken.
      </p>
      <img src={ch5_img6} alt='Dashboard Ansicht6' />
      <img src={ch5_img7} alt='Dashboard Ansicht7' />

      <h3>2. Mehrere Reifen löschen</h3>

      <p>
        Es ist auch möglich mehrere Reifen auf einmal zu löschen. Dafür geht man
        wieder in den Reiter Reifenbestand und wählt die richtige Flotte aus,
        klickt dann auf „Alle Reifen anzeigen“ und muss nun einen der oberen
        Reiter auswählen.{' '}
      </p>
      <img src={ch5_img8} alt='Dashboard Ansicht8' />

      <p>
        Die Reifen die „in Benutzung“ sind, kann man nicht löschen, bevor sie
        demontiert wurden. Man kann also nur aus der „Lagerung“ oder der
        „Recyclingbank“ Reifen löschen.{' '}
      </p>
      <img src={ch5_img9} alt='CO2OPT Übersicht9' />
      <p>
        Vorne links kann man nun einen Harken in die Box setzen, um gewisse
        Reifen auszuwählen. Abschließend muss man nur noch auf die rote
        Mülltonne klicken und dann nach Eingabe des richtigen Datums die Reifen
        löschen.
      </p>
      <img src={ch5_img10} alt='Flottenübersicht10' />
      <img src={ch5_img11} alt='Flottenübersicht11' />

      <h3>3. In der mobilen App</h3>

      <p>
        In der mobilen App kann man Reifen ganz einfach auf 2 Arten löschen. Für
        beide muss man erstmal den Reifen anklicken. Einmal klickt man nun
        direkt auf „Löschen“ und bestätigt nochmal mit „Löschen“.{' '}
      </p>

      <div className='flex gap-4 p-4'>
        <img src={ch5_img12} alt='Flottenübersicht12' />
        <img src={ch5_img13} alt='Flottenübersicht13' />
        <img src={ch5_img14} alt='Flottenübersicht14' />
      </div>
      <p>
        Alternativ geht man auf Reifen wechseln und setzt dann einen Harken an
        „Reifen beschädigt“. Danach klickt man nur noch „Dispose“ und man kann
        im Anschluss gleich einen neuen Reifen montieren.
      </p>

      <div className='flex gap-4 p-4'>
        <img src={ch5_img15} alt='Flottenübersicht15' />
        <img src={ch5_img16} alt='Flottenübersicht16' />
        <img src={ch5_img17} alt='Flottenübersicht17' />
      </div>
    </div>
};

export default Chapter5;
